import assets from '../assets';
import Avatar1 from '../images/avatar.png';
import Avatar2 from '../images/avatar_2.png';
import { getVerbiageKey, getVerbiageKeyWithPrefix } from '../utils';
import { cfgToThemeCdnPath, stateUi } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
import { get } from 'svelte/store';
const Card1 = assets.card1;
const Card2 = assets.card2;
const Card3 = assets.card3;
const Card4 = assets.card4;
const Card5 = assets.card5;
export let faqs = [
    {
        question: Verbiage[getVerbiageKey('question_vip_club_stand_out')],
        answer: Verbiage[getVerbiageKey('answer_vip_club_stand_out')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_how_ofter_bonuses')],
        answer: Verbiage[getVerbiageKey('answer_how_ofter_bonuses')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_which_tier_im_on')],
        answer: Verbiage[getVerbiageKey('answer_which_tier_im_on')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_what_is_rakeback')],
        answer: Verbiage[getVerbiageKey('answer_what_is_rakeback')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_what_is_happy_hour')],
        answer: Verbiage[getVerbiageKey('answer_what_is_happy_hour')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_what_are_calendar_distribuition_days')],
        answer: Verbiage[getVerbiageKey('answer_what_are_calendar_distribuition_days')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_what_is_cashback')],
        answer: Verbiage[getVerbiageKey('answer_what_is_cashback')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_how_communicate')],
        answer: Verbiage[getVerbiageKey('answer_how_communicate')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_monthly_bonus')],
        answer: Verbiage[getVerbiageKey('answer_monthly_bonus')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_daily_weekly_monthly')],
        answer: Verbiage[getVerbiageKey('answer_daily_weekly_monthly')],
        additionalContent: ''
    },
    {
        question: Verbiage[getVerbiageKey('question_wagering')],
        answer: Verbiage[getVerbiageKey('answer_wagering')],
        additionalContent: ''
    }
];
const faqListLength = get(stateUi).vip.faqListLength ?? 'full';
faqs = faqListLength === 'short' ? faqs.slice(0, 9) : faqs;
export const cardsData = [
    {
        image: Card1,
        title: Verbiage[getVerbiageKey('cashback_bonuses_description')],
        info: Verbiage[getVerbiageKey('earn_cashback_bonuses_description')],
        width: '50%',
        height: '327px',
        row: 1
    },
    {
        image: Card2,
        title: Verbiage[getVerbiageKey('rakeback_perks_description')],
        info: Verbiage[getVerbiageKey('earn_rakeback_rewards_description')],
        width: '50%',
        height: '327px',
        row: 1
    },
    {
        image: Card3,
        title: Verbiage[getVerbiageKey('rakeboost_happy_hour_description')],
        info: Verbiage[getVerbiageKey('triple_rakeback_description')],
        width: '100%',
        height: '210px',
        row: 2
    },
    {
        image: Card4,
        title: Verbiage[getVerbiageKey('level_up_rewards_description')],
        info: Verbiage[getVerbiageKey('level_up_rewards_earnings_description')],
        width: '50%',
        height: '327px',
        row: 3
    },
    {
        image: Card5,
        title: Verbiage[getVerbiageKey('consistent_rewards_description')],
        info: Verbiage[getVerbiageKey('maximize_playtime_rewards_description')],
        width: '50%',
        height: '327px',
        row: 3
    }
];
export const ranksData = [
    {
        name: 'Iron',
        badge: 'iron',
        progress: 5,
        amount: '$0',
        included: ['rakeback', 'rakeboost', 'daily-bonuses', 'weekly-bonuses', 'monthly-bonuses'],
        totalLevelUpReward: 0,
        calendarDistributionDays: 10,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        levels: [
            {
                level: '', // Base Iron level
                wagerRequirements: '$0',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '-', // No level-up reward
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 10
            },
            {
                level: 'I',
                wagerRequirements: '$1,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$2',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 10
            },
            {
                level: 'II',
                wagerRequirements: '$2,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$2',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 10
            },
            {
                level: 'III',
                wagerRequirements: '$3,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$2',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 10
            },
            {
                level: 'IV',
                wagerRequirements: '$4,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$4',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 10
            },
            {
                level: 'V',
                wagerRequirements: '$5,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$5',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 10
            }
        ]
    },
    {
        name: 'Bronze',
        badge: 'bronze',
        progress: 10,
        amount: '$10K',
        included: ['rakeback', 'rakeboost', 'daily-bonuses', 'weekly-bonuses', 'monthly-bonuses'],
        totalLevelUpReward: 25,
        calendarDistributionDays: 18,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar'
        ],
        levels: [
            {
                level: '', // Base Bronze level
                wagerRequirements: '$10,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$25',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 18
            },
            {
                level: 'I',
                wagerRequirements: '$11,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$3',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 18
            },
            {
                level: 'II',
                wagerRequirements: '$12,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$3',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 18
            },
            {
                level: 'III',
                wagerRequirements: '$13,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$3',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 18
            },
            {
                level: 'IV',
                wagerRequirements: '$14,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$3',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 18
            },
            {
                level: 'V',
                wagerRequirements: '$15,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$5',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 18
            }
        ]
    },
    {
        name: 'Silver',
        badge: 'silver',
        progress: 20,
        amount: '$25K',
        included: ['rakeback', 'rakeboost', 'daily-bonuses', 'weekly-bonuses', 'monthly-bonuses'],
        totalLevelUpReward: 35,
        calendarDistributionDays: 26,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase'
        ],
        levels: [
            {
                level: '', // Base Silver level
                wagerRequirements: '$25,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$35',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 26
            },
            {
                level: 'I',
                wagerRequirements: '$27,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$4',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 26
            },
            {
                level: 'II',
                wagerRequirements: '$30,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$4',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 26
            },
            {
                level: 'III',
                wagerRequirements: '$35,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$5',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 26
            },
            {
                level: 'IV',
                wagerRequirements: '$40,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$5',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 26
            },
            {
                level: 'V',
                wagerRequirements: '$45,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$5',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 26
            }
        ]
    },
    {
        name: 'Gold',
        badge: 'gold',
        progress: 30,
        amount: '$50K',
        included: ['rakeback', 'rakeboost', 'daily-bonuses', 'weekly-bonuses', 'monthly-bonuses'],
        totalLevelUpReward: 45,
        calendarDistributionDays: 34,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus'
        ],
        levels: [
            {
                level: '', // Base Gold level
                wagerRequirements: '$50,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$45',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 34
            },
            {
                level: 'I',
                wagerRequirements: '$55,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$10',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 34
            },
            {
                level: 'II',
                wagerRequirements: '$60,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$10',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 34
            },
            {
                level: 'III',
                wagerRequirements: '$65,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$10',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 34
            },
            {
                level: 'IV',
                wagerRequirements: '$70,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$10',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 34
            },
            {
                level: 'V',
                wagerRequirements: '$75,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$10',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 34
            }
        ]
    },
    {
        name: 'Platinum',
        badge: 'platinum',
        progress: 40,
        amount: '$100K',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus'
        ],
        totalLevelUpReward: 100,
        calendarDistributionDays: 42,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        levels: [
            {
                level: '', // Base Platinum level
                wagerRequirements: '$100,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$100',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 42
            },
            {
                level: 'I',
                wagerRequirements: '$120,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$20',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 42
            },
            {
                level: 'II',
                wagerRequirements: '$150,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$20',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 42
            },
            {
                level: 'III',
                wagerRequirements: '$180,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$20',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 42
            },
            {
                level: 'IV',
                wagerRequirements: '$200,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$20',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 42
            },
            {
                level: 'V',
                wagerRequirements: '$220,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$20',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 42
            }
        ]
    },
    {
        name: 'Diamond',
        badge: 'diamond',
        progress: 50,
        amount: '$250K',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        totalLevelUpReward: 200,
        calendarDistributionDays: 50,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        levels: [
            {
                level: '', // Base Diamond level
                wagerRequirements: '$250,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$200',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 50
            },
            {
                level: 'I',
                wagerRequirements: '$280,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 50
            },
            {
                level: 'II',
                wagerRequirements: '$310,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 50
            },
            {
                level: 'III',
                wagerRequirements: '$340,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 50
            },
            {
                level: 'IV',
                wagerRequirements: '$370,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$50',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 50
            },
            {
                level: 'V',
                wagerRequirements: '$400,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$50',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 50
            }
        ]
    },
    {
        name: 'Titanium',
        badge: 'titanium',
        progress: 60,
        amount: '$500K',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        totalLevelUpReward: 500,
        calendarDistributionDays: 58,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        levels: [
            {
                level: '', // Base Titanium level
                wagerRequirements: '$500,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$500',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 58
            },
            {
                level: 'I',
                wagerRequirements: '$600,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$100',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 58
            },
            {
                level: 'II',
                wagerRequirements: '$700,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$100',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 58
            },
            {
                level: 'III',
                wagerRequirements: '$800,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$100',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 58
            },
            {
                level: 'IV',
                wagerRequirements: '$900,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$150',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 58
            },
            {
                level: 'V',
                wagerRequirements: '$1,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$200',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 58
            }
        ]
    },
    {
        name: 'Obsidian',
        badge: 'obsidian',
        progress: 70,
        amount: '$2M',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        totalLevelUpReward: 2500,
        calendarDistributionDays: 66,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host'
        ],
        levels: [
            {
                level: '', // Base Obsidian level
                wagerRequirements: '$2,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$2,500',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 66
            },
            {
                level: 'I',
                wagerRequirements: '$3,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$3,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 66
            },
            {
                level: 'II',
                wagerRequirements: '$5,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$5,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 66
            },
            {
                level: 'III',
                wagerRequirements: '$10,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$10,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 66
            },
            {
                level: 'IV',
                wagerRequirements: '$20,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$15,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 66
            },
            {
                level: 'V',
                wagerRequirements: '$50,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$25,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 66
            }
        ]
    },
    {
        name: 'Emerald',
        badge: 'emerald',
        progress: 80,
        amount: '$100M',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus',
            'dedicated-vip-host',
            'exclusive-events'
        ],
        totalLevelUpReward: 40000,
        calendarDistributionDays: 74,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host',
            'exclusive-events'
        ],
        levels: [
            {
                level: '', // Base Emerald level
                wagerRequirements: '$100,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 74
            },
            {
                level: 'I',
                wagerRequirements: '$150,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 74
            },
            {
                level: 'II',
                wagerRequirements: '$200,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 74
            },
            {
                level: 'III',
                wagerRequirements: '$250,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 74
            },
            {
                level: 'IV',
                wagerRequirements: '$300,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$40,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 74
            },
            {
                level: 'V',
                wagerRequirements: '$350,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$50,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 74
            }
        ]
    },
    {
        name: 'Vibranium',
        badge: 'vibranium',
        progress: 90,
        amount: '$500M',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus',
            'dedicated-vip-host',
            'exclusive-events',
            'tailored-reload-bonuses'
        ],
        totalLevelUpReward: 150000,
        calendarDistributionDays: 82,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host',
            'exclusive-events',
            'tailored-reload-bonuses'
        ],
        levels: [
            {
                level: '', // Base Vibranium level
                wagerRequirements: '$500,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$150,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 82
            },
            {
                level: 'I',
                wagerRequirements: '$600,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$150,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 82
            },
            {
                level: 'II',
                wagerRequirements: '$700,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$150,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 82
            },
            {
                level: 'III',
                wagerRequirements: '$800,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$150,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 82
            },
            {
                level: 'IV',
                wagerRequirements: '$900,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$250,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 82
            }
        ]
    },
    {
        name: 'VIP',
        badge: 'vip',
        progress: 96,
        amount: '$1B',
        included: [
            'rakeback',
            'rakeboost',
            'daily-bonuses',
            'weekly-bonuses',
            'monthly-bonuses',
            'anniversary-bonus',
            'dedicated-vip-host',
            'exclusive-events',
            'tailored-reload-bonuses'
        ],
        totalLevelUpReward: 550000,
        calendarDistributionDays: 90,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'calendar',
            'distribution-day-increase',
            'anniversary-bonus',
            'dedicated-vip-host',
            'exclusive-events',
            'tailored-reload-bonuses'
        ],
        levels: [
            {
                level: '',
                wagerRequirements: '$1,000,000,000',
                rakeback: true,
                rakeboost: true,
                levelUpReward: '$550,000',
                dailyBonus: true,
                weeklyBonus: true,
                monthlyBonus: true,
                calendarClaimableDays: 90
            }
        ]
    }
];
export const ranksDataFomo = [
    {
        name: 'Iron',
        badge: 'iron',
        progress: 5,
        amount: '$1K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 10,
        levels: []
    },
    {
        name: 'Bronze',
        badge: 'bronze',
        progress: 10,
        amount: '$10K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback'
        ],
        totalLevelUpReward: 25,
        calendarDistributionDays: 18,
        levels: []
    },
    {
        name: 'Silver',
        badge: 'silver',
        progress: 20,
        amount: '$25K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback'
        ],
        totalLevelUpReward: 35,
        calendarDistributionDays: 26,
        levels: []
    },
    {
        name: 'Gold',
        badge: 'gold',
        progress: 30,
        amount: '$50K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase'
        ],
        totalLevelUpReward: 45,
        calendarDistributionDays: 34,
        levels: []
    },
    {
        name: 'Platinum',
        badge: 'platinum',
        progress: 40,
        amount: '$100K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase'
        ],
        totalLevelUpReward: 100,
        calendarDistributionDays: 42,
        levels: []
    },
    {
        name: 'Diamond',
        badge: 'diamond',
        progress: 50,
        amount: '$250K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions'
        ],
        totalLevelUpReward: 200,
        calendarDistributionDays: 50,
        levels: []
    },
    {
        name: 'Titanium',
        badge: 'titanium',
        progress: 60,
        amount: '$500K',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions'
        ],
        totalLevelUpReward: 500,
        calendarDistributionDays: 58,
        levels: []
    },
    {
        name: 'Obsidian',
        badge: 'obsidian',
        progress: 70,
        amount: '$2M',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus'
        ],
        totalLevelUpReward: 2500,
        calendarDistributionDays: 66,
        levels: []
    },
    {
        name: 'Emerald',
        badge: 'emerald',
        progress: 80,
        amount: '$100M',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus',
            'exclusive-vip-events'
        ],
        totalLevelUpReward: 40000,
        calendarDistributionDays: 74,
        levels: []
    },
    {
        name: 'Vibranium',
        badge: 'vibranium',
        progress: 90,
        amount: '$500M',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus',
            'exclusive-vip-events'
        ],
        totalLevelUpReward: 150000,
        calendarDistributionDays: 82,
        levels: []
    },
    {
        name: 'VIP',
        badge: 'vip',
        progress: 96,
        amount: '$1B',
        included: [],
        rewards: [
            'rakeback',
            'rakeboost',
            'total-level-up',
            'daily-cashback',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus',
            'exclusive-vip-events'
        ],
        totalLevelUpReward: 550000,
        calendarDistributionDays: 90,
        levels: []
    }
];
export const ranksDataTurbo = [
    {
        name: 'Iron',
        badge: 'iron',
        progress: 5,
        amount: '$1K',
        included: [],
        rewards: ['rakeback', 'total-level-up', 'weekly-cashback', 'monthly-cashback'],
        totalLevelUpReward: 0,
        calendarDistributionDays: 10,
        levels: []
    },
    {
        name: 'Bronze',
        badge: 'bronze',
        progress: 10,
        amount: '$10K',
        included: [],
        rewards: ['rakeback', 'total-level-up', 'weekly-cashback', 'monthly-cashback'],
        totalLevelUpReward: 25,
        calendarDistributionDays: 18,
        levels: []
    },
    {
        name: 'Silver',
        badge: 'silver',
        progress: 20,
        amount: '$25K',
        included: [],
        rewards: ['rakeback', 'total-level-up', 'weekly-cashback', 'monthly-cashback'],
        totalLevelUpReward: 35,
        calendarDistributionDays: 26,
        levels: []
    },
    {
        name: 'Gold',
        badge: 'gold',
        progress: 30,
        amount: '$50K',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase'
        ],
        totalLevelUpReward: 45,
        calendarDistributionDays: 34,
        levels: []
    },
    {
        name: 'Platinum',
        badge: 'platinum',
        progress: 40,
        amount: '$100K',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase'
        ],
        totalLevelUpReward: 100,
        calendarDistributionDays: 42,
        levels: []
    },
    {
        name: 'Diamond',
        badge: 'diamond',
        progress: 50,
        amount: '$250K',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions'
        ],
        totalLevelUpReward: 200,
        calendarDistributionDays: 50,
        levels: []
    },
    {
        name: 'Ruby',
        badge: 'ruby',
        progress: 60,
        amount: '$500K',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions'
        ],
        totalLevelUpReward: 500,
        calendarDistributionDays: 58,
        levels: []
    },
    {
        name: 'Sapphire',
        badge: 'sapphire',
        progress: 70,
        amount: '$2M',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus'
        ],
        totalLevelUpReward: 2500,
        calendarDistributionDays: 66,
        levels: []
    },
    {
        name: 'Emerald',
        badge: 'emerald',
        progress: 80,
        amount: '$100M',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus'
        ],
        totalLevelUpReward: 40000,
        calendarDistributionDays: 74,
        levels: []
    },
    {
        name: 'Black Diamond',
        badge: 'black_diamond',
        progress: 90,
        amount: '$500M',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus'
        ],
        totalLevelUpReward: 150000,
        calendarDistributionDays: 82,
        levels: []
    },
    {
        name: 'Legendary',
        badge: 'legendary',
        progress: 96,
        amount: '$1B',
        included: [],
        rewards: [
            'rakeback',
            'total-level-up',
            'weekly-cashback',
            'monthly-cashback',
            'rewards-increase',
            'invite-only-promotions',
            'dedicated-vip-host',
            'custom-vip-bonus'
        ],
        totalLevelUpReward: 550000,
        calendarDistributionDays: 90,
        levels: []
    }
];
export const ranksDataRocketbet = [
    {
        name: 'Earth',
        badge: 'earth',
        progress: 5,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        levels: []
    },
    {
        name: 'Moon',
        badge: 'moon',
        progress: 10,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        levels: []
    },
    {
        name: 'Mars',
        badge: 'mars',
        progress: 20,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        levels: []
    },
    {
        name: 'Jupiter',
        badge: 'jupiter',
        progress: 30,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus'
        ],
        levels: []
    },
    {
        name: 'Saturn',
        badge: 'saturn',
        progress: 40,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races'
        ],
        levels: []
    },
    {
        name: 'Uranus',
        badge: 'uranus',
        progress: 50,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts'
        ],
        levels: []
    },
    {
        name: 'Neptune',
        badge: 'neptune',
        progress: 60,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan'
        ],
        levels: []
    },
    {
        name: 'Pluto',
        badge: 'pluto',
        progress: 70,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan'
        ],
        levels: []
    },
    {
        name: 'Sun',
        badge: 'sun',
        progress: 80,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan',
            'brand-events'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan',
            'brand-events'
        ],
        levels: []
    },
    {
        name: 'Quasar',
        badge: 'quasar',
        progress: 90,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan',
            'brand-events'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan',
            'brand-events'
        ],
        levels: []
    },
    {
        name: 'Black Hole',
        badge: 'black_hole',
        progress: 96,
        amount: '-',
        included: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan',
            'brand-events'
        ],
        totalLevelUpReward: 0,
        calendarDistributionDays: 0,
        rewards: [
            'rakeback',
            'rakeboost',
            'level-up-reward',
            'daily-bonus',
            'weekly-bonus',
            'monthly-bonus',
            'vip-races',
            'vip-payouts',
            'dedicated-vip-host',
            'tailored-bonus-plan',
            'brand-events'
        ],
        levels: []
    }
];
export const testimonialsData = [
    {
        avatar: Avatar1,
        name: 'MonPetit',
        testimonial: Verbiage[getVerbiageKey('testimonial_1_text')]
    },
    {
        avatar: Avatar1,
        name: 'CinnamonStick',
        testimonial: Verbiage[getVerbiageKey('testimonial_2_text')]
    },
    {
        avatar: Avatar1,
        name: 'XsmithX',
        testimonial: Verbiage[getVerbiageKey('testimonial_3_text')]
    },
    {
        avatar: Avatar2,
        name: 'JTechDude',
        testimonial: Verbiage[getVerbiageKey('testimonial_4_text')]
    }
];
export const steps = [
    {
        id: 1,
        title: getVerbiageKey('step_1_text'),
        description: getVerbiageKey('step_1_description')
    },
    {
        id: 2,
        title: getVerbiageKey('step_2_text'),
        description: getVerbiageKey('step_2_description')
    },
    {
        id: 3,
        title: getVerbiageKey('step_3_text'),
        description: getVerbiageKey('step_3_description')
    }
];
export const aboutVipBg = cfgToThemeCdnPath('/about-vip/bg_vip_top.png');
export const cardsDataFomo = [
    {
        image: cfgToThemeCdnPath('/about-vip/cashback.png'),
        title: getVerbiageKey('cashback_bonuses_description'),
        subtitle: getVerbiageKey('cashback_bonuses02_description'),
        info: getVerbiageKey('earn_cashback_bonuses_description')
    },
    {
        image: cfgToThemeCdnPath('/about-vip/rakeback.png'),
        title: getVerbiageKey('rakeback_perks_description'),
        subtitle: getVerbiageKey('rakeback_perks02_description'),
        info: getVerbiageKey('earn_rakeback_rewards_description')
    },
    {
        image: cfgToThemeCdnPath('/about-vip/rakeboost_happy_hour.png'),
        title: getVerbiageKey('rakeboost_happy_hour_description'),
        subtitle: getVerbiageKey('rakeboost_happy_hour02_description'),
        info: getVerbiageKey('triple_rakeback_description')
    },
    {
        image: cfgToThemeCdnPath('/about-vip/level_up_rewards.png'),
        title: getVerbiageKey('level_up_rewards_description'),
        subtitle: getVerbiageKey('level_up_rewards02_description'),
        info: getVerbiageKey('level_up_rewards_earnings_description')
    },
    {
        image: cfgToThemeCdnPath('/about-vip/consistent_rewards.png'),
        title: getVerbiageKey('consistent_rewards_description'),
        subtitle: getVerbiageKey('consistent_rewards02_description'),
        info: getVerbiageKey('maximize_playtime_rewards_description')
    }
];
export const rankRowsTurbo = [
    { name: 'rakeback', id: 'rakeback' },
    { name: 'total_level_up_rewards', id: 'total-level-up' },
    { name: 'weekly_cashback', id: 'weekly-cashback' },
    { name: 'monthly_cashback', id: 'monthly-cashback' },
    { name: 'rewards_increase', id: 'rewards-increase' },
    { name: 'invite_only_promotions', id: 'invite-only-promotions' },
    { name: 'dedicated_vip_host', id: 'dedicated-vip-host' },
    { name: 'custom_vip_bonuses', id: 'custom-vip-bonus' }
];
export const rankRowsFomo = [
    { name: 'rakeback', id: 'rakeback' },
    { name: 'rakeboost', id: 'rakeboost' },
    { name: 'total_level_up_rewards', id: 'total-level-up' },
    { name: 'daily_cashback', id: 'daily-cashback' },
    { name: 'weekly_cashback', id: 'weekly-cashback' },
    { name: 'monthly_cashback', id: 'monthly-cashback' },
    { name: 'rewards_increase', id: 'rewards-increase' },
    { name: 'invite_only_promotions', id: 'invite-only-promotions' },
    { name: 'dedicated_vip_host', id: 'dedicated-vip-host' },
    { name: 'custom_vip_bonuses', id: 'custom-vip-bonus' },
    { name: 'exclusive_vip_events', id: 'exclusive-vip-events' }
];
